export function resolveWheelHomeViewPath (views, defaultPath) {
  const wheelView =
    views?.find(v => v.tagName === 'wheel' && v.isDefault) ??
    views?.find(v => v.tagName === 'wheel')
  return wheelView?.path || defaultPath
}
